import { useMemo } from 'react';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, REPORT } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

/**
 * @author Burak Ak
 */

const AgedOrdersReport = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'id',
				accessor: 'ID',
				filterType: FilterType.number,
				width: 50,
				show: false,
				showCopyButton: true
			},
			{
				Header: 'orderID',
				accessor: 'orderID',
				filterType: FilterType.string,
				width: 70,
				showOnMobile: true,
				showCopyButton: true
			},
			{
				Header: 'orderDate',
				accessor: 'createdAt',
				filterType: FilterType.date,
				width: 100,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'pickupLocation',
				accessor: 'pickupLocation',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.PICKUP_LOCATION
			},
			{
				Header: 'customerName',
				accessor: 'name',
				filterType: FilterType.string
			},
			{
				Header: 'customerPhone',
				accessor: 'telephone',
				filterType: FilterType.string,
				renderCell: ListComponents.PHONE
			},
			{
				Header: 'city',
				accessor: 'cityName',
				filterType: FilterType.multiSelection
			},
			{
				Header: 'deliveryCompany',
				accessor: 'deliveryName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.DELIVERY_COMPANIES_USED,
				width: 70,
				renderCell: ListComponents.DC_LOGO
			},
			{
				Header: 'shipmentNumber',
				accessor: 'shipmentNumber',
				filterType: FilterType.string,
				width: 100,
				renderCell: ListComponents.TRACKING_URL
			},
			{
				Header: 'pickupDate',
				accessor: 'pickupDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'grandTotal',
				accessor: 'grandTotal',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'subtotal',
				accessor: 'subTotal',
				filterType: FilterType.float,
				width: 90,
				show: false,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'totalDue',
				accessor: 'totalDue',
				filterType: FilterType.float,
				show: false,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'paymentMethod',
				accessor: 'paymentMethod',
				filterType: FilterType.multiSelection
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.multiSelection,
				renderCell: ListComponents.STATUS,
				showOnMobile: true
			},
			{
				Header: 'ecommerceStatus',
				accessor: 'ecomStatus',
				filterType: FilterType.multiSelection,
				renderCell: ListComponents.STATUS,
				roleName: 'SalesChannelModule',
				showOnMobile: true
			},
			{
				Header: 'comment',
				accessor: 'failedDeliveryComment',
				filterType: FilterType.string
			},
			{
				Header: 'undeliveredAttemptDate',
				accessor: 'undeliveredAttemptDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'undeliveredAttemptCnt',
				accessor: 'undeliveredAttemptCnt',
				filterType: FilterType.number
			},
			{
				Header: 'agedDays',
				accessor: 'agedDays',
				filterType: FilterType.number
			},
			{ Header: 'agedTransitDays', accessor: 'agedTransitDays', filterType: FilterType.number }
		],
		[]
	);

	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader
					lightTitle="reports"
					boldTitle="agedOrdersReport"
					icon={faArrowLeft}
					backUrl={mergePaths(PATHS.REPORTS, PATHS.ORDER_REPORTS)}
				/>
			</HeaderContainerFormHeader>

			<DynamicList
				id={DYNAMICLISTS.AGED_ORDERS_REPORT}
				columns={columns}
				fetchUrl={REPORT.LIST.GET_AGED_ORDERS_LIST}
				defaultSort={defaultSort}
				exportName="agedOrdersReport"
			/>
		</div>
	);
};

export default AgedOrdersReport;
